import React from "react";
import logo from "img/logo.png";
import { useAuth } from "providers/AuthProvider";
import { useConsoleState } from "providers/ConsoleStateProvider";
import { useHistory } from "react-router";
import { ConsoleRoleType } from "types/graphqlapi";

import { StyledHorizontalArea, StyledHeader } from "./styled";
import {
  IconButtonPresenter,
  IconTypes,
} from "components/parts/Button/IconButton/IconButton";
import { Typography } from "components/parts/Typography/Typography";
import { getRoleName } from "utils/common";

type HeaderProps = {
  clickPasswordChangeHandler: () => void;
  className: string;
};

export const Header: React.FC<HeaderProps> = ({
  clickPasswordChangeHandler,
  className,
}) => {
  const { userName, selectedGroupName, setUserInfo, role } = useConsoleState();
  const { userSignOut } = useAuth();
  const history = useHistory();

  const onClickLogout = () => {
    const confirm = window.confirm("ログアウトします");
    if (confirm) {
      userSignOut();
      setUserInfo("", "", ConsoleRoleType.GROUPUSER, false);
      history.goBack();
    } else return;
  };

  const returnNeutralPage = () => {
    history.replace(`/subject`);
  };

  return (
    <StyledHeader className={className}>
      <img src={logo} alt="ロゴ" width="150px" onClick={returnNeutralPage} />
      <StyledHorizontalArea>
        <Typography
          text={
            role === ConsoleRoleType.ADMINISTRATOR
              ? getRoleName(role)
              : role === ConsoleRoleType.ASMARQUSER
              ? getRoleName(role)
              : selectedGroupName
          }
          size="small"
        />
        <Typography text={userName} size="small" />
        {userName != "" && (
          <>
            <IconButtonPresenter
              iconName={IconTypes.LOCK}
              onClick={() => clickPasswordChangeHandler()}
              size="small"
              variant="secondary"
            />
            <IconButtonPresenter
              iconName={IconTypes.LOGOUT}
              onClick={() => onClickLogout()}
              size="small"
              variant="secondary"
            />
          </>
        )}
      </StyledHorizontalArea>
    </StyledHeader>
  );
};
